import React, { useEffect } from "react";
import {
  Container,
  Box,
  useColorModeValue,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { SidebarContent } from "./SidebarContent";
import { MobileTopBar } from "./MobileTopBar";
import { useAuth } from "../context/AuthContext";

export const DashboardLayout: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { refreshCurrentUser } = useAuth();

  useEffect(() => {
    refreshCurrentUser();
  }, [refreshCurrentUser]);

  return (
    <Container
      maxW={"1920px"}
      w="100%"
      minH="100dvh"
      h="100dvh"
      p="0px"
      overflow="hidden"
    >
      <HStack
        w="100%"
        h="100%"
        dir="rtl"
        display="flex"
        bg={useColorModeValue("gray.100", "dark.900")}
        p={{ base: "0", lg: "20px" }}
        spacing={{ base: "0", lg: "15px" }}
      >
        {/* Sidebar — hidden on mobile, visible on lg+ */}
        <Box
          display={{ base: "none", lg: "flex" }}
          h="100%"
          flexShrink={0}
          overflow="hidden"
          borderRadius={"2xl"}
        >
          <SidebarContent />
        </Box>

        {/* Main content area */}
        <Box
          w="100%"
          h="100%"
          minH={0}
          display="flex"
          flexDirection="column"
          bg={useColorModeValue("light.50", "dark.50")}
          borderRadius={{ base: "0", lg: "2xl" }}
          dir="rtl"
          overflow="hidden"
        >
          {/* Mobile top bar */}
          <Box display={{ base: "block", lg: "none" }} flexShrink={0}>
            <MobileTopBar onOpen={onOpen} />
          </Box>

          {/* Page content */}
          <Container
            maxW="container.2xl"
            flex={1}
            minH={0}
            overflowY="auto"
            overflowX="hidden"
            p={5}
          >
            <Outlet />
          </Container>
        </Box>
      </HStack>

      {/* Mobile sidebar drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xs">
        <DrawerOverlay />
        <DrawerContent dir="rtl" p={0} maxW="290px">
          <DrawerCloseButton />
          <Box h="100%" onClick={onClose}>
            <SidebarContent />
          </Box>
        </DrawerContent>
      </Drawer>
    </Container>
  );
};
